const languages = [
    {
        code: 'th',
        name: 'Thai',
        country_code: 'th',
    },
    {
        code: 'en',
        name: 'English',
        country_code: 'gb',
    },
    {
        code: 'jp',
        name: 'Japan',
        country_code: 'jp',
    },
]

export default languages;